import { inject, provide, InjectionKey, computed } from 'vue'
import { getContextForBrand } from '@invivodf/front-seller-auth/src/getContextForBrand'

// Single, framework-agnostic source of truth for the current applicative world.
// Derived from the brand (window.env.VUE_APP_CONTEXT) so it works both inside and
// outside a Vue setup() — router factory, route guard, main bootstrap, store, etc.
// Inside components, useContext() (injection-based, reactive) remains available.
export const getCurrentContext = (): Context =>
  getContextForBrand(window.env.VUE_APP_CONTEXT) === 'Retail' ? Context.Retail : Context.B2ag

export const isRetailContext = (): boolean => getCurrentContext() === Context.Retail

export const isB2agContext = (): boolean => getCurrentContext() === Context.B2ag

export enum Context {
  Retail = 'Retail',
  B2ag = 'B2ag',
}

export const contextSymbol: InjectionKey<Context> = Symbol('context')

export const provideContext = (context: Context): Context => {
  provide(contextSymbol, context)
  return context
}

export const useContext = () => {
  const context = inject(contextSymbol)
  if (!context) throw new Error(`Context is not provided`)

  const isRetail = computed(() => context === Context.Retail)
  const isB2ag = computed(() => context === Context.B2ag)

  return { isRetail, isB2ag }
}
